/**
 * Enterprise Security Utilities
 * 
 * Helper functions to check if Enterprise security features are enabled
 * for the current organization.
 */

import { subscriptionService } from '@/firebase/subscriptionService';

/**
 * Check if organization has Enterprise plan
 * 
 * @param organizationId - Organization ID
 * @returns Promise<boolean>
 */
export async function isEnterprisePlan(organizationId: string): Promise<boolean> {
  const result = await subscriptionService.getSubscription(organizationId);
  if (!result.success || !result.data) {
    return false;
  }
  
  const plan = result.data.plan;
  return plan === 'enterprise';
}

/**
 * Check if organization has client-side encryption enabled
 * 
 * @param organizationId - Organization ID
 * @returns Promise<boolean>
 */
export async function hasClientSideEncryption(organizationId: string): Promise<boolean> {
  return await subscriptionService.hasFeature(organizationId, 'client_side_encryption');
}

/**
 * Check if organization has CMEK enabled
 * 
 * @param organizationId - Organization ID
 * @returns Promise<boolean>
 */
export async function hasCMEK(organizationId: string): Promise<boolean> {
  return await subscriptionService.hasFeature(organizationId, 'cmek');
}

